import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Ribbon = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill={color || 'none'}
      xmlns="http://www.w3.org/2000/svg"
      stroke={stroke || 'currentColor'}
      {...props}
    >
      <path d="M5 8.64582C5.73294 9.47625 6.80531 10 8 10C9.19469 10 10.2671 9.47625 11 8.64582M5 8.64582C4.37764 7.94069 4 7.01445 4 6C4 3.79086 5.79086 2 8 2C10.2091 2 12 3.79086 12 6C12 7.01445 11.6224 7.94069 11 8.64582M5 8.64582L4.5 14L8 12.5L11.5 14L11 8.64582" />
    </svg>
  ),
)
Ribbon.displayName = 'Ribbon'

export default Ribbon
